var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
define(["require", "exports", "jquery", "../analytics", "../tooltip", "../util", "../favorites", "../renderCustomValance", "../querystring"], function (require, exports, $, analytics_1, tooltip_1, util_1, favorites_1, renderCustomValance_1, querystring_1) {
    "use strict";
    exports.__esModule = true;
    var TAG = 'share';
    var Actions;
    (function (Actions) {
        Actions[Actions["open"] = 0] = "open";
        Actions[Actions["exportReady"] = 1] = "exportReady";
        Actions[Actions["copyPricedLink"] = 2] = "copyPricedLink";
        Actions[Actions["copyUnpricedLink"] = 3] = "copyUnpricedLink";
        Actions[Actions["close"] = 4] = "close";
        Actions[Actions["sms"] = 5] = "sms";
        Actions[Actions["mail"] = 6] = "mail";
        Actions[Actions["facebook"] = 7] = "facebook";
        Actions[Actions["pinterest"] = 8] = "pinterest";
        Actions[Actions["openFeatured"] = 9] = "openFeatured";
    })(Actions || (Actions = {}));
    var shareActionIcons = Object.freeze({
        sms: '\ue076',
        mail: '\ue002',
        copy: '\ue921',
        publish: '\ue926',
        waiting: '\ue902',
        copyDesignbook: '\ue921',
        facebook: '\ue928',
        pinterest: '\ue927',
        twitter: '\ue92a'
    });
    var trackOnClick = function (action) { return "onclick='bundle.default.track(\"" + TAG + "\", \"" + action + "\")'"; };
    var renderLink = function (href, channel, text, linkClass) {
        var mobileOS = util_1.detectMobileOS();
        var smsLink = mobileOS === 'ios' ? "sms:&body=" + encodeURIComponent(href) : "sms:?&body=" + encodeURIComponent(href);
        switch (channel) {
            case 'copy':
            case 'copyDesignbook':
                return "<a class='" + (linkClass || 'hidden') + "' " + trackOnClick(channel) + " href='" + href + "' target='_blank'>" + (text || 'copy') + "</a>";
            case 'publish':
                return "<a id='shareAction_publish href='#' onclick='" + href + "'><span class='icon button'>" + shareActionIcons.publish + "</span><label>Publish link without price</label></a>";
            case 'mail':
                return "<a id='shareAction_mail' " + trackOnClick('mail') + " href='mailto:?subject=" + encodeURIComponent('Custom curtain design') + "&body=" + encodeURIComponent(href) + "'><span class='icon button'>" + shareActionIcons.mail + "</span><label>Mail</label></a>";
            case 'sms':
                return "<a id='shareAction_sms' " + trackOnClick('sms') + "  href='" + smsLink + "'><span class='button icon'>" + shareActionIcons.sms + "</span><label>Message</label></a>";
            case 'waiting':
                return "<a class='hidden' href='#'>" + shareActionIcons.waiting + "</a>";
            case 'facebook':
            case 'pinterest':
            case 'twitter':
                return '';
        }
    };
    var renderLabel = function (text, forId, skip) { return skip ? '' : "<label for='" + forId + "'>" + text + "</label>"; };
    var renderLinkOrLabel = function (s) {
        return s.buttonOnly
            ? ''
            : (s.className === 'copyDesignbook'
                ? renderLink(s.link, s.className, s.text, 'external-link')
                : renderLabel(s.text, "shareAction_" + s.className, s.directLink));
    };
    var renderActionButton = function (className, disabled, skip) {
        return skip ? '' : "<button type='button' id='shareAction_" + className + "' data-action='" + className + "' class='icon' " + (disabled ? 'disabled' : '') + ">" + shareActionIcons[className] + "</button>";
    };
    var renderSharableLink = function (s) { return "<div class='clipboard " + s.className + "'>" + renderLink(s.link, s.className) + " " + renderActionButton(s.className, !s.ready, s.directLink) + renderLinkOrLabel(s) + "</div>"; };
    var renderSharable = renderSharableLink;
    var ensureDialog = function () {
        var $dlg = $('.share-dialog');
        if ($dlg.length === 0) {
            $dlg = $('<div class="share-dialog lock-zoom"></div>');
            $dlg.appendTo($('body'));
            $dlg.on('click', '.clipboard button', handleShare);
        }
        return $dlg;
    };
    var copyLink = function (e) {
        e.preventDefault();
        e.stopPropagation();
        var $val = $(e.currentTarget).prev('a');
        var href = $val.attr('href');
        var action = href === window.location.href ? Actions.copyPricedLink : Actions.copyUnpricedLink;
        var $text = $('<input type="text" style="position:absolute;left:-9999px" readonly="true"/>').appendTo($('body'));
        $text.val(href);
        var text = $text[0];
        text.select();
        text.setSelectionRange(0, 2000);
        document.execCommand('copy');
        tooltip_1["default"]('copied', $(e.currentTarget));
        analytics_1["default"](TAG, Actions[action]);
    };
    var ensureImage = function () {
        var imageUrl = $('meta[property="og:image"]').attr('content');
        if (!imageUrl) {
            renderCustomValance_1.tryRenderCartImage()
                .then(function (file) {
                var formData = new FormData();
                formData.append('imageFile', file);
                return $.ajax({
                    url: '/shoppingCart/uploadCartImage',
                    type: 'POST',
                    data: formData,
                    dataType: 'json',
                    contentType: false,
                    processData: false
                });
            })
                .then(function (imageUrl) {
                $('head').append("<meta property=\"og:image\" content=\"" + imageUrl + "\"/>");
            });
        }
    };
    var handleShare = function (e) {
        var $button = $(e.currentTarget);
        var action = $button.data('action');
        var selfLink = window.location.href;
        var title = $('meta[property="og:title"]').attr('content') || favorites_1.getFavoriteName();
        var imageUrl = $('meta[property="og:image"]').attr('content');
        var search = window.location.search;
        if (search.length > 1) {
            var query = __assign({ ogimage: imageUrl, ogtitle: title }, querystring_1.parseQuery(search));
            search = querystring_1.formatQuery(query);
        }
        var href = window.location.protocol + "//" + window.location.host + window.location.pathname + search;
        switch (action) {
            case 'copy':
            case 'copyDesignbook':
                copyLink(e);
                break;
            case 'facebook':
                FB.ui({
                    method: 'share',
                    href: href
                }, function () {
                    analytics_1["default"](TAG, action);
                });
                break;
            case 'pinterest':
                PinUtils.pinOne({
                    url: selfLink,
                    media: imageUrl,
                    description: title
                });
                analytics_1["default"](TAG, action);
                break;
            case 'twitter':
                window.open("https://twitter.com/intent/tweet?text=" + encodeURIComponent(title) + "&url=" + encodeURIComponent(selfLink), '_blank');
                analytics_1["default"](TAG, action);
                break;
            default:
                analytics_1["default"](TAG, action);
                $button.prev('a').click();
                break;
        }
    };
    var shareActions = [
        {
            ready: true,
            directLink: false,
            text: 'Copy link',
            className: 'copy',
            link: null,
            buttonOnly: false
        },
        {
            ready: true,
            directLink: true,
            text: 'Message',
            className: 'sms',
            link: null,
            buttonOnly: false
        },
        {
            ready: true,
            directLink: true,
            text: 'Email',
            className: 'mail',
            link: null,
            buttonOnly: false
        },
        {
            ready: true,
            directLink: false,
            text: 'Facebook',
            className: 'facebook',
            link: null,
            buttonOnly: false
        },
        {
            ready: true,
            directLink: false,
            text: 'Pinterest',
            className: 'pinterest',
            link: null,
            buttonOnly: false
        },
        {
            ready: true,
            directLink: false,
            text: 'Twitter',
            className: 'twitter',
            link: null,
            buttonOnly: false
        }
    ];
    function shareDialog(extra) {
        var $dlg = ensureDialog();
        analytics_1["default"](TAG, Actions[extra ? Actions.open : Actions.openFeatured]);
        ensureImage();
        var $tip = $dlg.is(':visible') ? $dlg.find('.screen-tooltip') : $([]);
        var linkedActions = shareActions.map(function (x) { return (__assign({}, x, { link: window.location.href })); });
        var linkedButtonWithLabels = linkedActions.filter(function (x) { return !x.buttonOnly; });
        var labeledButtons = linkedButtonWithLabels.map(renderSharable).join('');
        var unlabeledButtons = linkedActions.filter(function (x) { return x.buttonOnly; }).map(renderSharable).join('');
        $dlg.empty().append($(labeledButtons));
        if (extra) {
            $dlg.append(renderSharable(extra));
        }
        $dlg.append("<div class='social-buttons'>" + unlabeledButtons + "</div>");
        if ($tip.length > 0) {
            $tip.appendTo($dlg.find('.clipboard:first-child button'));
        }
        $dlg.dialog('show');
    }
    exports.shareDialog = shareDialog;
});



//////////////////
// WEBPACK FOOTER
// ./Scripts/built/dialogs/share.js
// module id = 50
// module chunks = 0